<div class="register-success">
  <div class="container">
    <div class="fa"><i class="fa fa-check-circle" aria-hidden="true"></i></div>
    <div class="header-text">{{ 'module.public.registerSuccess.headerText' | translate }}</div>
    <div class="bottom-text">{{ 'module.public.registerSuccess.bottomText' | translate }}</div>
    <button class="btn btn-outline-primary" (click)="goToLogin()">
      {{ 'module.public.registerSuccess.btnText' | translate }}
    </button>
  </div>
</div>
